import React, { useEffect, useState } from 'react';
import axios from 'axios';
import {
  Container,
  Row,
  Col,
  Card,
  CardHeader,
  CardBody,
  Table,
  Button,
  FormGroup,
  Label,
  Input,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Spinner,
  Pagination,
  PaginationItem,
  PaginationLink,
  FormText
} from 'reactstrap';
import { toast } from 'react-toastify';
import { apiURL1 } from '../../config';
import Header from '../../components/Headers/Header';
import Footer from 'components/Footers/Footer';
import { FaEdit, FaTrash, FaPlus } from 'react-icons/fa';

const baseURL = apiURL1;

function ExamComponents() {
  const token = localStorage.getItem('token');

  const [components, setComponents] = useState([]);
  const [loading, setLoading] = useState(true);
  const [errors, setErrors] = useState({});

  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [totalPages, setTotalPages] = useState(0);
  const [search, setSearch] = useState('');

  const [addModal, setAddModal] = useState(false);
  const [editModal, setEditModal] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [name, setName] = useState('');
  const [selected, setSelected] = useState(null);

  useEffect(() => {
    fetchComponents();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page, limit]);

  const fetchComponents = async () => {
    setLoading(true);
    try {
      const response = await axios.get(`${baseURL}/superadmin/exam-components`, {
        headers: { 'Authorization': `Bearer ${token}` },
        params: { page, limit, search: search?.trim() || undefined }
      });
      if (response.data && response.data.success) {
        setComponents(Array.isArray(response.data.data) ? response.data.data : []);
        const tp = response.data?.pagination?.totalPages || 0;
        setTotalPages(tp);
      } else {
        setComponents([]);
        toast.error(response.data?.message || 'Failed to fetch exam components');
      }
    } catch (error) {
      console.error('Error fetching exam components:', error);
      toast.error(error.response?.data?.message || 'Error fetching exam components');
      setComponents([]);
      setTotalPages(0);
    } finally {
      setLoading(false);
    }
  };

  const validate = () => {
    const newErrors = {};
    let ok = true;
    if (!name || typeof name !== 'string' || !name.trim()) {
      newErrors.name = 'Other Activities name is required';
      ok = false;
    }
    setErrors(newErrors);
    return ok;
  };

  const toggleAdd = () => {
    setAddModal(!addModal);
    setName('');
    setErrors({});
  };

  const openEdit = (item) => {
    setSelected(item);
    setName(item?.name || '');
    setErrors({});
    setEditModal(true);
  };

  const closeEdit = () => {
    setEditModal(false);
    setSelected(null);
    setName('');
  };

  const openDelete = (item) => {
    setSelected(item);
    setDeleteModal(true);
  };

  const closeDelete = () => {
    setDeleteModal(false);
    setSelected(null);
  };

  const handleAdd = async () => {
    if (!validate()) return;
    setLoading(true);
    try {
      const response = await axios.post(
        `${baseURL}/superadmin/exam-components`,
        { name: name.trim() },
        { headers: { 'Authorization': `Bearer ${token}` } }
      );
      if (response.data && response.data.success) {
        toast.success('Exam Other Activities created');
        toggleAdd();
        fetchComponents();
      } else {
        toast.error(response.data?.message || 'Error creating exam Other Activities');
      }
    } catch (error) {
      console.error('Error creating exam Other Activities:', error);
      toast.error(error.response?.data?.message || 'Error creating exam Other Activities');
    } finally {
      setLoading(false);
    }
  };

  const handleUpdate = async () => {
    if (!validate() || !selected?._id) return;
    setLoading(true);
    try {
      const response = await axios.put(
        `${baseURL}/superadmin/exam-components/${selected._id}`,
        { name: name.trim() },
        { headers: { 'Authorization': `Bearer ${token}` } }
      );
      if (response.data && response.data.success) {
        toast.success('Exam Other Activities updated');
        closeEdit();
        fetchComponents();
      } else {
        toast.error(response.data?.message || 'Error updating exam Other Activities');
      }
    } catch (error) {
      console.error('Error updating exam Other Activities:', error);
      toast.error(error.response?.data?.message || 'Error updating exam Other Activities');
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async () => {
    if (!selected?._id) return;
    setLoading(true);
    try {
      const response = await axios.delete(
        `${baseURL}/superadmin/exam-components/${selected._id}`,
        { headers: { 'Authorization': `Bearer ${token}` } }
      );
      if (response.data && response.data.success) {
        toast.success('Exam Other Activities deleted');
        closeDelete();
        fetchComponents();
      } else {
        toast.error(response.data?.message || 'Error deleting exam Other Activities');
      }
    } catch (error) {
      console.error('Error deleting exam Other Activities:', error);
      toast.error(error.response?.data?.message || 'Error deleting exam Other Activities');
    } finally {
      setLoading(false);
    }
  };

  const onSearchSubmit = (e) => {
    e?.preventDefault();
    setPage(1);
    fetchComponents();
  };

  if (loading && !addModal && !editModal && !deleteModal) {
    return (
      <>
        <Header />
        <Container>
          <Row>
            <Col>
              <div style={{ display: 'flex', justifyContent: 'center' }}>
                <Spinner color="primary" />
              </div>
            </Col>
          </Row>
        </Container>
      </>
    );
  }

  return (
    <>
      <Header />
      <Container>
        <Row>
          <Col>
            <Card>
              <CardHeader style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <h3>Mid Term Components</h3>
                <div style={{ display: 'flex', gap: 12, alignItems: 'center' }}>
                  <form onSubmit={onSearchSubmit} style={{ display: 'flex', gap: 8 }}>
                    <Input
                      type="text"
                      placeholder="Search by name"
                      value={search}
                      onChange={(e) => setSearch(e.target.value)}
                    />
                    <Button color="secondary" size="sm" type="submit">Search</Button>
                  </form>
                  <Button color="primary" size="sm" onClick={toggleAdd}>
                    <FaPlus /> Add New
                  </Button>
                </div>
              </CardHeader>
              <CardBody>
                <Table className="table">
                  <thead>
                    <tr style={{ backgroundColor: '#2980b9', color: 'white' }}>
                      <th>Name</th>
                      <th>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {components.map((item) => (
                      <tr key={item._id}>
                        <td>{item.name}</td>
                        <td>
                          <Button color="warning" size="sm" style={{ marginRight: 8 }} onClick={() => openEdit(item)}>
                            <FaEdit /> Edit
                          </Button>
                          <Button color="danger" size="sm" onClick={() => openDelete(item)}>
                            <FaTrash /> Delete
                          </Button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </Table>

                {totalPages > 1 && (
                  <Pagination aria-label="Components pagination">
                    <PaginationItem disabled={page === 1}>
                      <PaginationLink first onClick={() => setPage(1)} />
                    </PaginationItem>
                    <PaginationItem disabled={page === 1}>
                      <PaginationLink previous onClick={() => setPage((p) => Math.max(1, p - 1))} />
                    </PaginationItem>
                    {Array.from({ length: totalPages }, (_, i) => i + 1).map((p) => (
                      <PaginationItem key={p} active={p === page}>
                        <PaginationLink onClick={() => setPage(p)}>{p}</PaginationLink>
                      </PaginationItem>
                    ))}
                    <PaginationItem disabled={page === totalPages}>
                      <PaginationLink next onClick={() => setPage((p) => Math.min(totalPages, p + 1))} />
                    </PaginationItem>
                    <PaginationItem disabled={page === totalPages}>
                      <PaginationLink last onClick={() => setPage(totalPages)} />
                    </PaginationItem>
                  </Pagination>
                )}
              </CardBody>
            </Card>
          </Col>
        </Row>
        <Footer />
      </Container>

      {/* Add Modal */}
      <Modal isOpen={addModal} toggle={toggleAdd}>
        <ModalHeader toggle={toggleAdd}>Add Mid Term Other Activities</ModalHeader>
        <ModalBody>
          <FormGroup>
            <Label for="name">Name</Label>
            <Input
              type="text"
              id="name"
              placeholder="Enter Other Activities name"
              value={name}
              onChange={(e) => setName(e.target.value)}
              invalid={!!errors.name}
            />
            {errors.name && <FormText color="danger">{errors.name}</FormText>}
          </FormGroup>
        </ModalBody>
        <ModalFooter>
          <Button color="primary" onClick={handleAdd} disabled={loading}>
            {loading ? <Spinner size="sm" /> : 'Add'}
          </Button>
          <Button color="secondary" onClick={toggleAdd}>Cancel</Button>
        </ModalFooter>
      </Modal>

      {/* Edit Modal */}
      <Modal isOpen={editModal} toggle={closeEdit}>
        <ModalHeader toggle={closeEdit}>Edit Mid Term Other Activities</ModalHeader>
        <ModalBody>
          <FormGroup>
            <Label for="edit-name">Name</Label>
            <Input
              type="text"
              id="edit-name"
              placeholder="Enter Other Activities name"
              value={name}
              onChange={(e) => setName(e.target.value)}
              invalid={!!errors.name}
            />
            {errors.name && <FormText color="danger">{errors.name}</FormText>}
          </FormGroup>
        </ModalBody>
        <ModalFooter>
          <Button color="primary" onClick={handleUpdate} disabled={loading}>
            {loading ? <Spinner size="sm" /> : 'Update'}
          </Button>
          <Button color="secondary" onClick={closeEdit}>Cancel</Button>
        </ModalFooter>
      </Modal>

      {/* Delete Modal */}
      <Modal isOpen={deleteModal} toggle={closeDelete}>
        <ModalHeader toggle={closeDelete}>Delete Mid Term Other Activities</ModalHeader>
        <ModalBody>
          <p>Are you sure you want to delete this Other Activities?</p>
        </ModalBody>
        <ModalFooter>
          <Button color="danger" onClick={handleDelete} disabled={loading}>
            {loading ? <Spinner size="sm" /> : 'Delete'}
          </Button>
          <Button color="secondary" onClick={closeDelete}>Cancel</Button>
        </ModalFooter>
      </Modal>
    </>
  );
}

export default ExamComponents;